<script>
import HowToReturnGR from "@/components/HowToReturnGR.vue";
import HowToReturnCY from "@/components/HowToReturnCY.vue";
import {useOrderDataStore} from "@/stores/orderDataStore";

export default{
  name:'HowToReturnPage',
  methods: {useOrderDataStore},
  components: {HowToReturnGR, HowToReturnCY},
  data(){
    return{
      orderDataStore:useOrderDataStore()
    }
  }
};
</script>

<template>
  <HowToReturnGR v-if="orderDataStore.shippingCountry==='GR'"></HowToReturnGR>
  <HowToReturnCY v-else></HowToReturnCY>
</template>

